import { render, staticRenderFns } from "./CreateNewProduct.vue?vue&type=template&id=6c59ed54&"
import script from "./CreateNewProduct.vue?vue&type=script&lang=ts&"
export * from "./CreateNewProduct.vue?vue&type=script&lang=ts&"
import style0 from "./CreateNewProduct.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports